module.exports = __webpack_public_path__ + "static/media/cobriraboga (1).b4411209.png";